/* Our trustpilot score out of 5. This usually looks best with a single number after a decimal point */
export const TRUSTPILOT_SCORE_STRING = '4.4';
/* Our count of trustpilot reviews, abbreviated with a metric suffix, it may or may not have a decimal point (e.g. 4.1k, 4k) */
export const TRUSTPILOT_REVIEW_COUNT_STRING = '4k';

/* The number of five-star reviews, written as an expanded string, e.g. 3,000 */
export const TRUSTPILOT_FIVE_STAR_REVIEW_COUNT_EXPANDED_STRING = '3,200';
